import { css } from '@emotion/react';
import { wplToken } from '@atlassiansox/wpl-token';

export const containerStyles = css`
  margin: ${wplToken('space.400')} ${wplToken('space.250')};
`;

export const headerStyles = css`
  margin: 0;
  padding: 0;
  font-weight: 500;
  font-size: 1.125rem;
  font-family: var(--bxp-charlie-text-font-family);
`;

export const fieldsetStyles = css`
  border: none;
  display: grid;
  grid-template-columns: auto auto 1fr;
  gap: ${wplToken('space.400')};
  padding: 0;
`;
